import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.object.assign.js";
import { __awaiter } from "tslib";
import cx from 'classnames';
import React, { useState, useLayoutEffect, useMemo, useRef } from 'react';
import { useUnmountedRef } from 'ahooks';
import { CSSTransition } from 'react-transition-group';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { isDataURL } from '../../utils/is-data-url';
import { preloadImage } from '../../utils/preload-image';
import { imageToDataURL } from '../../utils/image-to-data-url';
import { SpokesIcon } from '../toast/spokes-icon';
import Mask from '../mask';
import SafeArea from '../safe-area';
import NavBar from '../nav-bar';
import Toast from '../toast';
import ShareChannelPicker from '../share-channel-picker';
import { normalizeChannels } from './image-share-channel';
var classPrefix = 'nib-image-sharing';
/** 动画入场持续时长（单位：毫秒） */

var ENTER_TIMEOUT = 300;
/** 动画离场持续时长（单位：毫秒） */

var EXIT_TIMEOUT = 200;
/** 图片分享浮层背景色 */

export var OVERLAY_BGCOLOR = '#606A7E';
/** 渠道选择区域背景色 */

export var CHANNEL_BGCOLOR = '#FFFFFF';
var defaultProps = {
  visible: false,
  title: '分享图片',
  channels: [],
  showTitleBar: false,
  closeIcon: 'close',
  closeOnChannelClick: true,
  closeOnImageClick: false,
  imageErrorTips: '图片加载失败',
  autoSafeArea: true
};
export var ImageSharing = function ImageSharing(p) {
  var _cx, _cx2;

  var props = mergeProps(defaultProps, p);
  var unmountedRef = useUnmountedRef();
  var imageContainerRef = useRef(null);
  var imageRef = useRef(null);
  var pickerRef = useRef(null);

  var _useState = useState(false),
      imageScrollable = _useState[0],
      setImageScrollable = _useState[1];

  var _useState2 = useState('none'),
      imageState = _useState2[0],
      setImageState = _useState2[1];

  var _useState3 = useState(null),
      imageDataURL = _useState3[0],
      setImageDataURL = _useState3[1];

  var _useState4 = useState('none'),
      pickerState = _useState4[0],
      setPickerState = _useState4[1];

  var channels = useMemo(function () {
    return normalizeChannels(props.channels);
  }, [props.channels]);
  useLayoutEffect(function () {
    if (!props.visible) {
      return;
    }

    (function () {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _a, image, _yield, imageElement, _imageDataURL, container, _getComputedStyle, paddingLeft, paddingRight, containerPadding, containerRadio, imageRadio;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setImageState('loading');
                _context.prev = 1;

                if (!(typeof props.image === 'function')) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return props.image();

              case 5:
                _context.t0 = _context.sent;
                _context.next = 9;
                break;

              case 8:
                _context.t0 = props.image;

              case 9:
                image = _context.t0;
                _context.next = 12;
                return isDataURL(image) ? preloadImage(image).then(function (imageElement) {
                  return {
                    imageElement: imageElement,
                    imageDataURL: image
                  };
                }) : imageToDataURL(image);

              case 12:
                _yield = _context.sent;
                imageElement = _yield.imageElement;
                _imageDataURL = _yield.imageDataURL;

                if (!unmountedRef.current) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return");

              case 17:
                container = imageContainerRef.current;
                _getComputedStyle = getComputedStyle(container), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
                containerPadding = parseFloat(paddingLeft) + parseFloat(paddingRight);
                containerRadio = container.offsetHeight / (container.offsetWidth - containerPadding);
                imageRadio = (imageElement.height +
                /** breathing */
                32) / imageElement.width;
                setTimeout(function () {
                  if (!unmountedRef.current) {
                    setImageState('loaded');
                  }
                }, ENTER_TIMEOUT);
                setImageScrollable(imageRadio > containerRadio);
                setImageDataURL(_imageDataURL);
                setPickerState('enter');
                _context.next = 33;
                break;

              case 28:
                _context.prev = 28;
                _context.t1 = _context["catch"](1);
                setImageState('failed');

                if (props.imageErrorTips) {
                  Toast.show(Object.assign(Object.assign({}, Toast.DEFAULT_PROPS), {
                    content: props.imageErrorTips
                  }));
                }

                (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 28]]);
      }));
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [props.visible]);

  var afterClose = function afterClose() {
    var _a;

    setImageScrollable(false);
    setImageState('none');
    setImageDataURL(null);
    setPickerState('none');
    (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
  };

  return withNativeProps(props, /*#__PURE__*/React.createElement(Mask, {
    visible: props.visible,
    destroyOnClose: true,
    disableBodyScroll: true,
    enterTimeout: 100,
    exitTimeout: EXIT_TIMEOUT,
    style: {
      background: OVERLAY_BGCOLOR
    },
    onMaskClick: props.onClose,
    afterShow: props.afterShow,
    afterClose: afterClose,
    className: cx(classPrefix, (_cx = {}, _cx[classPrefix + "-without-title-bar"] = !props.showTitleBar, _cx))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix + "-main", props.mainClassName),
    style: Object.assign(Object.assign({}, props.mainStyle), {
      // @ts-ignore
      '--enter-timeout': ENTER_TIMEOUT + "ms",
      '--exit-timeout': EXIT_TIMEOUT + "ms",
      '--channel-row-count': Math.ceil(channels.length / 4)
    })
  }, props.showTitleBar && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SafeArea, {
    position: "top",
    className: props.topSafeAreaClassName,
    style: props.topSafeAreaStyle
  }), /*#__PURE__*/React.createElement(NavBar, {
    backIcon: props.closeIcon,
    onBack: props.onClose
  }, props.title)), /*#__PURE__*/React.createElement("div", {
    ref: imageContainerRef,
    className: cx(classPrefix + "-preview", (_cx2 = {}, _cx2[classPrefix + "-preview-scrollable"] = imageScrollable, _cx2)),
    onClick: function onClick() {
      var _a;

      if (props.closeOnImageClick && imageState === 'loaded') {
        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
      }
    }
  }, imageState === 'loading' && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-loading"
  }, /*#__PURE__*/React.createElement(SpokesIcon, null)), /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: imageRef,
    in: imageState === 'loaded',
    timeout: {
      enter: ENTER_TIMEOUT,
      exit: EXIT_TIMEOUT
    },
    classNames: classPrefix + "-preview-image",
    onEntered: props.onImageReady,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("img", {
    ref: imageRef,
    src: imageDataURL,
    className: classPrefix + "-preview-image"
  }))), pickerState === 'none' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-placeholder"
  }), props.autoSafeArea && /*#__PURE__*/React.createElement(SafeArea, {
    position: "bottom"
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: pickerRef,
    in: Boolean(props.visible && pickerState !== 'none'),
    timeout: {
      enter: ENTER_TIMEOUT,
      exit: EXIT_TIMEOUT
    },
    classNames: classPrefix + "-picker",
    unmountOnExit: true,
    onEntered: function onEntered() {
      setPickerState('entered');
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: pickerRef,
    className: classPrefix + "-picker"
  }, /*#__PURE__*/React.createElement(ShareChannelPicker, {
    channels: channels,
    autoSafeArea: props.autoSafeArea,
    style: {
      '--background-color': CHANNEL_BGCOLOR
    },
    onChannelClick: function onChannelClick(channel) {
      var _a, _b;

      (_a = props.onChannelClick) === null || _a === void 0 ? void 0 : _a.call(props, {
        channel: channel,
        dataURL: imageDataURL
      });

      if (props.closeOnChannelClick) {
        (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props);
      }
    }
  }))))));
};